import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable } from 'rxjs/index';
import { OrganizationService } from '../../services/organization.service';
import { Organization } from '../../types/organization';
import { LoginService } from '../../services/login.service';
import { LogService } from '../../services/log.service';

@Component({
  selector: 'app-form-input-field',
  template: `
    <div class="form-group row">
      <label for="test" class="col-2 col-form-label col-form-label-lg">test</label>
      <div class="col-6">
        <ng-content></ng-content>
      </div>
    </div>
  `
})
export class FormInputFieldComponent implements OnInit {
  @Input()
  name = 'name';
  @Input()
  label = 'Label here';

  constructor(private log: LogService) {}

  ngOnInit() {}
}
